import React from 'react'
import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'

import {
  SectionTitle,
  SectionDivider,
  SectionSubtitle,
} from '../../../components/Section'

const Heading = ({children}) => {
  const {t} = useTranslation('customers')

  return (
    <>
      <SectionTitle text={t('UnpaidInvoices.Heading.title')}>
        {children}
      </SectionTitle>
      <SectionDivider />
      <SectionSubtitle text={t('UnpaidInvoices.Heading.description')} />
    </>
  )
}

Heading.defaultProps = {
  children: null,
}

Heading.propTypes = {
  children: PropTypes.node,
}

export default Heading
